import React from 'react';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class TlLeveling1To55RankPicker extends React.PureComponent {
    static describeRank = rank => rank.toString();

    static minValue = 1;
    static maxValue = 55;

    static getDefaultValue = () => [1, 50];

    static marks = {
        1: '1',
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        55: '55',
    };

    render() {
        const {intl, collapsed, value, onChange} = this.props;

        return (
            <div>
                <div className="range-inputs">
                    <div className="range-inputs__item">
                        <RestrictedNumberInput
                            label={intl.formatMessage({id: 'section.product.level'})}
                            min={TlLeveling1To55RankPicker.minValue}
                            max={TlLeveling1To55RankPicker.maxValue}
                            value={value[0]}
                            onChange={newValue => onChange([
                                newValue,
                                value[1]
                            ])}
                        />
                    </div>

                    <div className="range-inputs__divider"/>

                    <div className="range-inputs__item">
                        <RestrictedNumberInput
                            label={intl.formatMessage({id: 'section.product.wanted'})}
                            min={TlLeveling1To55RankPicker.minValue}
                            max={TlLeveling1To55RankPicker.maxValue}
                            value={value[1]}
                            onChange={newValue => onChange([
                                value[0],
                                newValue
                            ])}
                        />
                    </div>
                </div>

                {!collapsed && (
                    <div className="slider">
                        <VariableStepRange
                            className="rc-slider-wow-leveling-classic"
                            step={1}
                            min={TlLeveling1To55RankPicker.minValue}
                            max={TlLeveling1To55RankPicker.maxValue}
                            marks={TlLeveling1To55RankPicker.marks}
                            value={value}
                            onChange={onChange}
                        />
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/tl/TlLeveling1To55RankPicker.js